import React from "react";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <h2 className="home-title">Welcome to Admin Panel</h2>
      <div className="nav-buttons">
        <button className="nav-btn" onClick={() => navigate("/dashboard")}>
          Go to Dashboard
        </button>
        <button className="nav-btn" onClick={() => navigate("/schedule")}>
          Go to Schedule
        </button>
        <button className="nav-btn" onClick={() => navigate("/other-banners")}>
          Other Banners
        </button>
      </div>
    </div>
  );
}
